import React from 'react';
import { Title, TitleProps, Button, ButtonProps } from '@soluto-design/react';
import cls from '@soluto-design/styles/cls';

export interface BlockTitleButtonProps {
    title?: string;
    titleTag?: TitleProps['component'];
    button?: ButtonProps;
}

const BlockTitleButton = ({
    title,
    titleTag = 'h3',
    button,
}: BlockTitleButtonProps) => {
    return (
        <div className="row mb-xl gap-y-24">
            {title && (
                <Title
                    isHtml
                    className={cls(
                        'col-span-full text-h300 text-text-primary',
                        button && 'md:col-span-6 xl:col-span-10',
                    )}
                    component={titleTag}>
                    {title}
                </Title>
            )}
            {button && (
                <div
                    className={cls(
                        'col-span-full text-b600 text-text-secondary flex md:justify-end',
                        'md:col-span-2',
                        !title &&
                            'md:col-span-full xl:col-span-full md:justify-start',
                    )}>
                    {button && (
                        <Button
                            variant="secondary"
                            size="large"
                            {...button}
                            className={cls('min-w-[108px] md:min-w-[116px]')}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default BlockTitleButton;
